(() => {
  'use strict';
  if (!document.querySelector('[data-psi-catalog-results]') || !window.fetch || !window.AbortController) return;
  const header = document.getElementById('site-header');
  const measureHeader = () => document.documentElement.style.setProperty('--psi-catalog-header-bottom', Math.max(0, header?.getBoundingClientRect().bottom || 0) + 'px');
  if(header && window.ResizeObserver) new ResizeObserver(measureHeader).observe(header);
  window.addEventListener('resize', measureHeader, {passive:true});
  window.addEventListener('scroll', measureHeader, {passive:true});
  measureHeader();
  const ids = ['collection-hero', 'psi-catalog-results'];
  const status = document.getElementById('psi-catalog-status');
  const cache = new Map();
  let controller, serial = 0;
  const emit = name => document.dispatchEvent(new CustomEvent(name));
  const fieldValues = form => new URLSearchParams(new FormData(form)).toString();
  const catalog = () => document.querySelector('[data-psi-catalog-results]');
  const isForm = form => form?.matches('form.psi-chip-filter-form,form.collection-filter-form') && (form.closest('[data-psi-catalog-results]') || form.closest('#psi-filter-sheet-host'));
  function busy(value) {
    document.body.classList.toggle('psi-catalog-loading', value);
    catalog()?.setAttribute('aria-busy', String(value));
    if (status) status.textContent = value ? status.dataset.loading : status.dataset.done;
  }
  function prepare(root = document) {
    root.querySelectorAll('[data-psi-catalog-results] form.collection-filter-form [onchange]').forEach(field => field.removeAttribute('onchange'));
    root.querySelectorAll('.psi-filter-pop:not(.psi-filter-pop-all) form.psi-chip-filter-form, #psi-filter-sheet-host .psi-filter-sheet-single form.psi-chip-filter-form').forEach(form => {
      if (form.dataset.psiAsyncReady) return;
      form.dataset.psiAsyncReady = 'true';
      const title = form.querySelector('.psi-chip-filter-title');
      const label = title?.textContent.trim() || '';
      if (/taglia|misura|size|numero/i.test(label)) form.classList.add('psi-size-form');
      if (/color/i.test(label)) form.classList.add('psi-colour-form');
      if (title && !title.dataset.caption) {
        title.dataset.caption = label;
        title.textContent = status.dataset.filterBy + ' ' + (/taglia|misura|size/i.test(label) ? status.dataset.size : label);
      }
      const before = fieldValues(form);
      const apply = form.querySelector('.psi-chip-apply');
      const update = () => { if (apply) apply.disabled = fieldValues(form) === before; };
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      update();
    });
  }
  function request(url, signal) {
    const key = url.href;
    const cached = cache.get(key);
    if (cached && Date.now() - cached.time < 15000) return Promise.resolve(cached.data);
    const endpoint = new URL(key);
    endpoint.searchParams.set('sections', ids.join(','));
    return fetch(endpoint, {signal, credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(response => { if(!response.ok) throw new Error('Catalog response'); return response.json(); })
      .then(data => {
        if(ids.some(id => !data[id])) throw new Error('Catalog section missing');
        cache.set(key,{time:Date.now(),data});
        if(cache.size>8) cache.delete(cache.keys().next().value);
        return data;
      });
  }
  function valid(url) { return url.origin === location.origin && /\/collections\/[^/]+\/?$/.test(url.pathname) && !url.searchParams.has('view'); }
  async function navigate(url, pop = false, restoreY = null) {
    if(!valid(url)) { location.assign(url.href); return; }
    const run = ++serial;
    controller?.abort();
    controller = new AbortController();
    const track = document.querySelector('.psi-catalog-categories__track');
    const trackX = track?.scrollLeft || 0;
    const oldY = scrollY;
    if(!pop) history.replaceState({...history.state,psiCatalog:true,scrollY:oldY},'',location.href);
    emit('psi:catalog-before-update');
    busy(true);
    try {
      const data = await request(url,controller.signal);
      if(run!==serial) return;
      const parser = new DOMParser();
      const incoming = ids.map(id => parser.parseFromString(data[id],'text/html').getElementById('shopify-section-'+id));
      if(incoming.some(el=>!el) || !incoming[1].querySelector('[data-psi-catalog-results]')) throw new Error('Incomplete catalog');
      if(!pop) history.pushState({psiCatalog:true,scrollY:oldY},'',url.href);
      ids.forEach((id,i)=>document.getElementById('shopify-section-'+id).replaceWith(incoming[i]));
      document.title = catalog().dataset.pageTitle;
      document.querySelector('link[rel="canonical"]')?.setAttribute('href',catalog().dataset.canonical);
      emit('psi:catalog-updated');
      prepare();
      const nextTrack = document.querySelector('.psi-catalog-categories__track');
      if(nextTrack) {
        nextTrack.scrollLeft = trackX;
        const active = nextTrack.querySelector('[aria-current="page"]');
        if(active) {
          const a=active.getBoundingClientRect(),t=nextTrack.getBoundingClientRect();
          if(a.left<t.left) nextTrack.scrollLeft-=t.left-a.left+12;
          else if(a.right>t.right) nextTrack.scrollLeft+=a.right-t.right+12;
        }
      }
      window.scrollTo({top:restoreY ?? oldY,behavior:'instant'});
    } catch(error) {
      if(run!==serial || error.name==='AbortError') return;
      location.assign(url.href);
    } finally {
      if(run===serial) busy(false);
    }
  }
  document.addEventListener('click',event=>{
    if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link=event.target.closest('a[href]');
    if(!link || link.target || link.hasAttribute('download')) return;
    if(!link.closest('.psi-catalog-categories') && !link.matches('[data-psi-catalog-results] .psi-filter-clear,[data-psi-catalog-results] .active-filter-pill,[data-psi-catalog-results] .psi-filter-reset,[data-psi-catalog-results] .psi-chip-link,#psi-filter-sheet-host .psi-filter-reset')) return;
    const url=new URL(link.href);
    if(!valid(url)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(url.href!==location.href) navigate(url);
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!isForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url=new URL(form.action,location.href);
    url.search='';
    for(const [key,value] of new FormData(form)) if(value!=='') url.searchParams.append(key,value);
    navigate(url);
  },true);
  document.addEventListener('change',event=>{
    const field=event.target;
    const form=field.form;
    if(field.matches('[data-psi-catalog-results] .sort-select')) {
      event.stopImmediatePropagation();
      const url=new URL(location.href);url.searchParams.set('sort_by',field.value);url.searchParams.delete('page');navigate(url);return;
    }
    if(isForm(form) && form.matches('.collection-filter-form') && field.type==='checkbox') {
      event.stopImmediatePropagation();
      form.requestSubmit();
    }
  },true);
  document.addEventListener('psi:filter-hydrated',()=>requestAnimationFrame(()=>prepare()));
  document.addEventListener('toggle',event=>{
    if(event.target.matches?.('.psi-filter-pop') && event.target.open) requestAnimationFrame(()=>prepare());
  },true);
  window.addEventListener('popstate',event=>{
    if(event.state?.psiCatalog) navigate(new URL(location.href),true,event.state.scrollY||0);
  });
  history.replaceState({...history.state,psiCatalog:true,scrollY},'',location.href);
  prepare();
})();